import React, { useEffect, useRef } from "react";
import { ModalUi } from "../../../ui/ModalUi";
import { TipoButtonConstants } from "../../../../types/typesConstants";
import { ButtonUi } from "../../../ui/ButtonUi";
import { FormUi } from "../../../ui/FormUi";
import { Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { ModuloForm } from "./ModuloForm";
import {
  moduloClearActive,
  moduloStartAdd,
  moduloStartUpdate,
} from "../../../../actions/usuario";

const initialValues = (data = {}) => ({
  id: data?.id || dayjs().valueOf(),
  nombre: data?.nombre || null,
  state: data?.state || true,
});
const useResetFormOnCloseModal = ({ form, open, activeModulo }) => {
  const prevOpenRef = useRef();

  useEffect(() => {
    prevOpenRef.current = open;
  }, [open]);
  const prevOpen = prevOpenRef.current;

  useEffect(() => {
    if (!open && prevOpen) {
      form.resetFields();
    }
    if (open) {
      //Abrir Modal
      if (activeModulo)
        //entro editar
        form.setFieldsValue({
          ...activeModulo,
        });
      //entro nuevo
      else form.setFieldValue("id", new dayjs().valueOf());
    }
  }, [form, prevOpen, open]);
};
export const ModuloModal = ({ open, handleCloseModal }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { activeModulo } = useSelector((state) => state.usuario);
  useResetFormOnCloseModal({ form, open, activeModulo });
  const handleClose = () => {
    dispatch(moduloClearActive());
    handleCloseModal();
  };
  const handleSave = (values) => {
    if (activeModulo) dispatch(moduloStartUpdate(values));
    else dispatch(moduloStartAdd(values));
    handleClose();
  };
  return (
    <ModalUi
      title="Mantenimiento de módulo"
      open={open}
      onCancel={handleClose}
      footer={[
        <ButtonUi
          key="back"
          typeUi={TipoButtonConstants.Cancelar}
          onClick={handleClose}
        />,
        <ButtonUi
          key="submit"
          typeUi={TipoButtonConstants.Guardar}
          htmlType="submit"
          form="FormModulo"
        />,
      ]}
      forceRender
    >
      <FormUi
        name="FormModulo"
        form={form}
        layout="vertical"
        autoComplete="off"
        initialValues={initialValues(activeModulo)}
        handleSubmit={handleSave}
      >
        <ModuloForm />
      </FormUi>
    </ModalUi>
  );
};
